import { OverlayRef } from '@angular/cdk/overlay'
import { filter, Observable, Subject, take } from 'rxjs'

import { MobileNavComponent } from './mobile-nav.component'

export class SideNavRef {
  readonly close$: Observable<void>
  private readonly closeSubject = new Subject<void>()

  constructor(
    private overlayRef: OverlayRef,
    private sideNav: MobileNavComponent,
  ) {
    this.close$ = this.closeSubject.asObservable()
    this.sideNav.afterAnimationStateChanged$
      .pipe(
        filter((v) => v === 'void'),
        take(1),
      )
      .subscribe(() => this.actuallyClose())
  }

  readonly close = () => {
    this.sideNav.close()
    this.overlayRef.detachBackdrop()
    this.closeSubject.next()
    this.closeSubject.complete()
  }

  private actuallyClose() {
    this.overlayRef.dispose()
  }
}
